module.exports = "<button type=\"button\" class=\"btn btn-sm btn-default float-right\" (click)=\"showNewListForm()\">\n\t<i class=\"fa fa-plus\" title=\"New Task List\"></i> New Task List\n</button>\n<h2>Tasklists</h2>\n<task-list-editor *ngIf=\"newListFormVisible\" [list]=\"newTasklist\" (onCancel)=\"onNewListCancel()\" (onSave)=\"onNewListSave()\"></task-list-editor>\n<section class=\"task-list-container\">\n\t<task-list *ngFor=\"let list of myLists\" [list]=\"list\"></task-list>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tasklists/task-list-manager.component.html
// module id = ./src/app/tasklists/task-list-manager.component.html
// module chunks = 0